import { useMemo } from 'react'
import { URLSearchParamsInit, useSearchParams } from 'react-router-dom'

export type Entity = {
    _id: string
    type: string
}

export type StatisticQueryParams = {
    from?: Date
    to?: Date
    chart?: string
    breakdown?: string
    cumulation?: string
    context?: Entity[]
}

export function useStatisticParams() {
    const [searchParams, setSearchParams] = useSearchParams()
    const config = useMemo<StatisticQueryParams>(
        () => ({
            from: searchParams.has('from') ? new Date(searchParams.get('from')!) : undefined,
            to: searchParams.has('to') ? new Date(searchParams.get('to')!) : undefined,
            chart: searchParams.get('chart') ?? undefined,
            breakdown: searchParams.get('breakdown') ?? undefined,
            cumulation: searchParams.get('cumulation') ?? undefined,
            context: searchParams.has('context')
                ? searchParams.getAll('context').map((e) => {
                      const [type, _id] = e.split(':')
                      return { _id, type }
                  })
                : [],
        }),
        [searchParams],
    )

    const getQueryParams = (newConfig: StatisticQueryParams) =>
        ({
            from: newConfig.from ? newConfig.from.toISOString() : undefined,
            to: newConfig.to ? newConfig.to.toISOString() : undefined,
            chart: newConfig.chart,
            breakdown: newConfig.breakdown,
            cumulation: newConfig.cumulation,
            context: newConfig.context ? newConfig.context.map((e) => `${e.type}:${e._id}`) : undefined,
        }) as URLSearchParamsInit

    const setConfig = (newConfig: StatisticQueryParams) => setSearchParams(getQueryParams(newConfig))

    return [config, setConfig, getQueryParams] as [StatisticQueryParams, typeof setConfig, typeof getQueryParams]
}
